import { render, staticRenderFns } from "./formPage.vue?vue&type=template&id=c5824298&scoped=true"
import script from "./formPage.vue?vue&type=script&lang=js"
export * from "./formPage.vue?vue&type=script&lang=js"
import style0 from "./formPage.vue?vue&type=style&index=0&id=c5824298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5824298",
  null
  
)

export default component.exports